import React, { useEffect, useState } from 'react';
import { Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';
import useStyles from 'isomorphic-style-loader/useStyles';

import { Container } from '../../../../symphony';

import { SlDataService } from '../../services/sl-data.service';

import s from './FreezeLayer.scss';
import { lePlaygroundContext } from '../../global-constants';

export function FreezeLayer(): JSX.Element {
	useStyles(s);
	const [isVisible, setIsVisible] = useState<boolean>(false);

	useEffect(() => {
		const unsubscriber = new Subject<void>();

		const { freezeLayer$ } = Container.take(
			lePlaygroundContext.value,
			SlDataService,
		);
		freezeLayer$
			.pipe(takeUntil(unsubscriber), tap(setIsVisible))
			.subscribe();

		return () => {
			unsubscriber.next();
			unsubscriber.complete();
		};
	}, []);

	return isVisible ? <div className="freeze-layer" /> : null;
}
